<template>
    <div>
        <b-card no-body>
            <b-card-header class="flexRowCenter">
                <b class="flex2">LA Sex Trafficking Tool</b>
                <router-link v-if="isAllowedToCreateOrEditPerson" :to="addScreeningLink">
                    <b-button variant="outline-primary" class="headerBtn">Add Screening</b-button>
                </router-link>
                <b-button v-else disabled variant="outline-primary" class="headerBtn">Add Screening</b-button>
            </b-card-header>

            <!-- <b-button @click="showAddOldTsModal = true" variant="primary" class="headerBtn>Add Stopgap Solution</b-button> -->

<!-- The new Screening entries -->
            <div v-if="screenings.length > 0">
                <b-list-group
                    v-for="s in screenings"
                    :key="s.id"
                    flush
                >
                    <b-list-group-item>
                        <router-link :to="`/traffickingScreening/${s.id}/view/conclusion`">
                            {{$moment(s.createdAt).format('MM/DD/YYYY')}} {{s.id}}
                            <img
                                class="s-icon"
                                v-if="s.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1"
                                src="/static/img/ConcernPossible.png"
                                height="21"
                                width="21"
                            />
                            <img
                                class="s-icon"
                                v-if="s.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2"
                                src="/static/img/ConcernDanger.png"
                                height="21"
                                width="21"
                            />
                            <img
                                v-if="sIsShared(s)"
                                :src="'/static/img/shareYes.png'"
                                height="21"
                                width="21"
                            >
                        </router-link>
                    </b-list-group-item>
                </b-list-group>
            </div>

            <div v-if="screenings.length > 0 && oldScreenings.length > 0" :style="{borderBottom: '1px solid #00000020'}"></div>
            
            <!-- The old screening entries -->
            <div v-if="oldScreenings.length > 0">
                <b-list-group
                    v-for="screening in oldScreenings"
                    :key="screening._id"
                    flush
                >
                    <b-list-group-item @click="setViewOldScreening(screening)">
                        <a href @click.prevent class="concl_">
                            {{ $moment(screening.createdAt).format('MM/DD/YYYY') }}
                            {{ screening.id }}
                        </a>
                        <img
                            v-if="screening.conclusion == OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM.CONCERN"
                            class="s-icon"
                            :src="'/static/img/ConcernPossible.png'"
                            height="21"
                            width="21"
                        >
                        <img                        
                            v-if="screening.conclusion == OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM.INDICATED"
                            class="s-icon"
                            :src="'/static/img/ConcernDanger.png'"
                            height="21"
                            width="21"
                        >
                    </b-list-group-item>
                </b-list-group>
            </div>

            <div v-if="screenings.length > 0 || oldScreenings.length > 0">
                <router-link :to="'/person/' + personId + '/edit?tabIndex=1'" v-if="isAllowedToCreateOrEditPerson">
                    <b-button
                        type="button"
                        variant="danger"
                        size="md"
                        class="mb-3"
                        style="margin-left: 1.25rem;"
                    >
                        <span class="button-text">Update Victim Status</span>
                    </b-button>
                </router-link>
            </div>
            <div v-if="oldScreenings.length === 0 && screenings.length === 0">
                <b-list-group flush>
                    <b-list-group-item>
                        <p>
                            No Sex Trafficking Screenings
                        </p>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </b-card>

        <AddOldTraffickingScreeningModal
            v-if="showAddOldTsModal"
            :personId="person._id"
            @close="closeAddOldTsModal"
        />
       
        <ViewOldTraffickingScreeningModal
            v-if="showViewOldTsModal"
            :personId="person._id"
            :screening="viewOldScreening"
            @close="closeViewOldTsModal"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM, TRAFFICKING_SCREENING_CONCLUSION_ENUM } from '../../helpers/enums'
import AddOldTraffickingScreeningModal from '../../views/t1/AddOldTraffickingScreeningModal.vue'
import ViewOldTraffickingScreeningModal from '../../views/t1/ViewOldTraffickingScreeningModal.vue'

export default {
    name: 'TraffickingScreeningCard',

    components: {AddOldTraffickingScreeningModal, ViewOldTraffickingScreeningModal},

    props: {
        oldScreenings: {
            type: Array,
            default () {
                return []
            }
        },
        screenings: {
            type: Array,
            default () {
                return []
            }
        },
        isAllowedToCreateOrEditPerson: {
            type: Boolean,
            default: false
        },
        person: {
        type: Object,
            default () {
            return {}
        }
    },
        personId: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM,
            TRAFFICKING_SCREENING_CONCLUSION_ENUM,
            showAddOldTsModal: false,
            showViewOldTsModal: false,
            viewOldScreening: null
        }
    },

    computed: {
        ...mapGetters({
            sharePersonRecords: 'sharePersonRecords'
        }),

        addScreeningLink () {
            return `/traffickingscreening/${this.personId}/add`
        }
    },

    methods: {
        sIsShared () {
            return this.sharePersonRecords.length
        },

        setViewOldScreening (screening) {
            this.viewOldScreening = screening
            // this.showViewTraffickingScreeningModal()
            this.showViewOldTsModal = true
        },

        closeAddOldTsModal () {
            this.$store.dispatch('initOldTraffickingScreening')
            this.showAddOldTsModal = false
        },

        closeViewOldTsModal () {
            this.$store.dispatch('initOldTraffickingScreening')
            this.viewOldScreening = null
            this.showViewOldTsModal = false
        }
    }
}
</script>

<style>
.flexRowCenter {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.flex2 {
    flex: 2;
}

.s-icon {
    margin-left: 3px;
    position: relative;
    top: -1px;
}
</style>


// WEBPACK FOOTER //
// src/components/TraffickingScreening/TraffickingScreeningCard.vue